module.exports = __webpack_public_path__ + "static/clip-1-87d0a8fc4e6610c31963058c948f57fe.jpg";